import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link, useParams } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"

const GETDATABYID = "api/vartman"
const EDITDATA = 'api/vartman/update'

function EditVartman() {

    const { id } = useParams()
    const [editabledata, Setalleditabledata] = useState([]);
    const [loading, Setloading] = useState(false)
    const navigate = useNavigate();

    document.title = "Edit Vartman Chaubisi- Jain Sadhana"

    useEffect(() => {
        const getdatabyid = async () => {
            try {
                const response = await axios.get(`${GETDATABYID}/${id}`)
                const data = response.data.vartmanchaubisi
                Setalleditabledata(data)


            } catch (error) {
                console.log(error.response.data.message)

            }
        }
        getdatabyid();
    }, [])

    const HandleEdit = async (event) => {
        Setloading(true)
        event.preventDefault();

        const data = new FormData();

        data.append('englishtitle', editabledata.englishtitle);
        data.append('hindititle', editabledata.hindititle);
        data.append('englishpratik', editabledata.englishpratik);
        data.append('hindipratik', editabledata.hindipratik);
        data.append('content', editabledata.content);
        data.append('introname', editabledata.introname);
        data.append('introfather', editabledata.introfather);
        data.append('intromother', editabledata.intromother);
        data.append('introkull', editabledata.introkull);
        data.append('garbhplace', editabledata.garbhplace);
        data.append('garbhtithi', editabledata.garbhtithi);
        data.append('nakshatra', editabledata.nakshatra);
        data.append('janmplace', editabledata.janmplace);
        data.append('janmtithi', editabledata.janmtithi);
        data.append('image', editabledata.image);

        try {
            const response = await axios.patch(`${EDITDATA}/${id}`, data)
            if (response.status === 200) {
                navigate('/vartmanlist')
                toast.success(' Successfully Edited')
                Setloading(false)
            }

        } catch (error) {
            console.log(error?.response?.data?.message)
            setTimeout(()=>Setloading(false),1000)
        }

    }



    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav MasterTitleClass="active" vartman="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black text-capitalize'  >Edit vartman chaubisi</p>
                                    <Link to="/vartmanlist" className='text-black btn button-yellow text-capitalize back-list-button'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All vartman chaubisi</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleEdit}>
                                        <div className="row employ-form-list">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.englishtitle} onChange={(event) => Setalleditabledata({ ...editabledata, englishtitle: event.target.value })} className="form-control  bg-gray border border-0" id="englishtitle" name='englishtitle' placeholder="Vartman Chaubisi English Title" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.hindititle} onChange={(event) => Setalleditabledata({ ...editabledata, hindititle: event.target.value })} className="form-control  bg-gray border border-0" id="hindititle" name='hindititle' placeholder="Vartman Chaubisi Hindi Title" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.englishpratik} onChange={(event) => Setalleditabledata({ ...editabledata, englishpratik: event.target.value })} className="form-control  bg-gray border border-0" id="englishpratik" name='englishpratik' placeholder="Pratik Chinh in English" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.hindipratik} onChange={(event) => Setalleditabledata({ ...editabledata, hindipratik: event.target.value })} className="form-control  bg-gray border border-0" id="hindipratik" name='hindipratik' placeholder="Pratik Chinh in Hindi" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12">

                                                        <div className="mb-3">
                                                            <textarea value={editabledata.content} onChange={(event) => Setalleditabledata({ ...editabledata, content: event.target.value })} style={{ height: "150px" }} className="form-control  bg-gray border border-0" id="content" name='content' placeholder="Vartman Chaubisi Content" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className=" mb-3">
                                                            <input name="image" onChange={(event) => Setalleditabledata({ ...editabledata, image: event.target.files[0] })} type="file" className="form-control " id="upload-file" required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.introname} onChange={(event) => Setalleditabledata({ ...editabledata, introname: event.target.value })} className="form-control  bg-gray border border-0" id="introname" name='introname' placeholder="Name" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.introfather} onChange={(event) => Setalleditabledata({ ...editabledata, introfather: event.target.value })} className="form-control  bg-gray border border-0" id="introfather" name='introfather' placeholder="Father's Name" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.intromother} onChange={(event) => Setalleditabledata({ ...editabledata, intromother: event.target.value })} className="form-control  bg-gray border border-0" id="intromother" name='intromother' placeholder="Mother's Name" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.introkull} onChange={(event) => Setalleditabledata({ ...editabledata, introkull: event.target.value })} className="form-control  bg-gray border border-0" id="introkull" name='introkull' placeholder="Kull Name" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.garbhplace} onChange={(event) => Setalleditabledata({ ...editabledata, garbhplace: event.target.value })} className="form-control  bg-gray border border-0" id="garbhplace" name='garbhplace' placeholder="Garbh Place" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.garbhtithi} onChange={(event) => Setalleditabledata({ ...editabledata, garbhtithi: event.target.value })} className="form-control  bg-gray border border-0" id="garbhtithi" name='garbhtithi' placeholder="Garbh tithi" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.nakshatra} onChange={(event) => Setalleditabledata({ ...editabledata, nakshatra: event.target.value })} className="form-control  bg-gray border border-0" id="nakshatra" name='nakshatra' placeholder="Nakshatra" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.janmplace} onChange={(event) => Setalleditabledata({ ...editabledata, janmplace: event.target.value })} className="form-control  bg-gray border border-0" id="janmplace" name='janmplace' placeholder="Janm Place" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" value={editabledata.janmtithi} onChange={(event) => Setalleditabledata({ ...editabledata, janmtithi: event.target.value })} className="form-control  bg-gray border border-0" id="janmtithi" name='janmtithi' placeholder="Janm Tithi" required />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                            {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/vartmanlist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EditVartman